import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-[#222] bg-[#0a0a0a]" data-id="element-37">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-38">
        <div className="flex items-center gap-2" data-id="element-39">
          <div className="w-6 h-6 bg-[#ff6b35] rounded-full flex items-center justify-center" data-id="element-40">
            <span className="font-bold text-white text-xs font-['Syne']" data-id="element-41">
              M
            </span>
          </div>
          <span className="font-bold text-lg tracking-tight font-['Syne']" data-id="element-42">
            Mockup.ai
          </span>
        </div>

        <div className="flex gap-8 text-sm text-[#666]" data-id="element-43">
          <a href="#" className="hover:text-[#f5f5f5] transition-colors" data-id="element-44">
            Privacy
          </a>
          <a href="#" className="hover:text-[#f5f5f5] transition-colors" data-id="element-45">
            Terms
          </a>
          <a href="#" className="hover:text-[#f5f5f5] transition-colors" data-id="element-46">
            Twitter
          </a>
          <a href="#" className="hover:text-[#f5f5f5] transition-colors" data-id="element-47">
            GitHub
          </a>
        </div>

        <div className="text-sm text-[#444]" data-id="element-48">© 2024 Mockup AI Inc.</div>
      </div>
    </footer>;
}